import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TooltipOne from '../../../../../components/TooltipOne/TooltipOne.component';
import { IconButton } from '@mui/material';

export const OpenAssessmentSessionCell: React.FC = () => {
  return (
    <TooltipOne
      title="Edycja danych nie jest możliwa, ponieważ sesja zmieniła status na otwarty"
      placement="top"
      data-testid="Ostrzeżenie"
    >
      <IconButton
        disableRipple
        area-label="Ostrzeżenie"
        sx={{
          marginRight: '5px',
          color: '#FF9A02',
          '&:hover': {
            background: 'rgba(255, 154, 2, 0.1)',
          },
        }}
        size="small"
      >
        <WarningAmberIcon fontSize="small" />
      </IconButton>
    </TooltipOne>
  );
};
